import { createGenericSlice, DjangoModel } from '@store/slices/generic.slice'
import { EntityId } from '@reduxjs/toolkit'
import { RootState } from '@store/store'

export const stationUrl = 'radio-station'

export interface RadioPresetModel extends DjangoModel {
  headlineCount: string
  newsCount: string
  stationId: EntityId
  broadcastingHours: string[]
  availableJingles: EntityId[]
  defaultAreaId: EntityId | null
}

export interface StationModel extends DjangoModel {
  name: string
  radioPreset: RadioPresetModel
}

const {
  slice: stationSlice,
  thunks: stationThunks,
  adapter: stationAdapter,
  selectors,
} = createGenericSlice<StationModel>(
  'station',
  stationUrl,
  {}
  //stationExtraReducers  Initial state can be customized if needed
)

// export const stationAdapterExport = stationAdapter

export const { fetchAll: fetchAllStations } = stationThunks

export const { selectAll: selectAllStations, selectById: selectStationById } =
  stationAdapter.getSelectors<RootState>((state: RootState) => state.station)

export const {
  selectLoading: selectStationLoading,
  selectIsIdInProgress: selectIsStationIdInProgress,
  selectError: selectStationError,
} = selectors

export default stationSlice.reducer
